export const sortFields = ['name'] as const;

export const adminSortFields = ['name'] as const;

// oxlint-disable-next-line no-unused-vars
type _AdminSortFieldsSafetyNet<
	T extends (typeof sortFields)[number] = (typeof adminSortFields)[number],
> = T;
